import axios from 'axios'
export const getBannerAPI = () => {
  return axios({
    url: 'https://capi.supercells.pro/app/api/banner/pc/list',
    method: 'GET',
  })
}